//#region src/assets/no-active-credit-card.svg
var no_active_credit_card_default = "" + new URL("no-active-credit-card-DlJi7CZk.svg", import.meta.url).href;
//#endregion
export { no_active_credit_card_default as default };

//# sourceMappingURL=no-active-credit-card.js.map